import styles from "./Account.module.css";

const Billing = () => {
  return (
    <div className={styles.billing__area}>
      <div className={styles.billing__title}>Billing</div>
      <div className={styles.billing__description}>
        You will not be charged during private release!
      </div>
    </div>
  );
};

export default Billing;
